import { render } from "./RegelvergleichBox.pug?vue&type=template&id=946c8f7e&lang=pug"
import script from "./RegelvergleichBox.js?vue&type=script&lang=js"
export * from "./RegelvergleichBox.js?vue&type=script&lang=js"

import "./RegelvergleichBox.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__